<template>
  <section class="p-2">
    <v-card-title class="d-flex justify-space-between p-0 m-0">
      <div class="ps-2 headingFontsize">Partner Branch</div>
      <div>
        <bread-crumb :bread-crumbs="['Branch Summary']" />
      </div>
    </v-card-title>
    <v-data-table
      fixed-header
      height="55vh"
      :headers="headers"
      :items="BranchesData"
      :search="search"
      item-key="name"
    >
      <template v-slot:item.actions="{ item }">
        <div class="d-flex">
          <v-icon
            small
            title="Users list"
            color="info"
            class="mr-2"
            @click="
              $router.push({
                name: 'User Summary',
                query: {
                  partner_code: item.branch_code,
                  partner_id: parent_partner_id,
                  branch_id: item.branch_id,
                },
              })
            "
          >
            mdi-account-outline
          </v-icon>
          <v-icon small color="success" class="mr-2" @click="editItem(item)">
            mdi-content-save-edit-outline
          </v-icon>
          <v-icon small color="primary" class="mr-2" @click="deleteItem(item)">
            mdi-trash-can-outline
          </v-icon>
        </div>
      </template>

      <template v-slot:top>
        <v-divider class="p-0 m-0 primary--text"></v-divider>
        <v-col class="mt-5">
          <v-row>
            <v-col class="mt-1">
              <v-btn
                depressed
                small
                class="text-capitalize me-3 text-decoration-none"
                color="primary"
                @click="
                  $router.push({
                    name: 'Branch Setup',
                    query: {
                      parent_partner_id: parent_partner_id,
                      country_cd: $route.query.country_cd,
                    },
                  })
                "
                >Create Branch</v-btn
              >
              <v-btn depressed @click="downloadExcelsheet" color="primary" small
                ><v-icon small>mdi-file-excel-outline</v-icon>Export
              </v-btn>
            </v-col>
            <v-col></v-col>
          </v-row>
          <v-row>
            <v-col></v-col>
            <v-col cols="12" md="4"
              ><v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Type here to filter the table data."
                hide-details
                class="me-4 mb-2"
                dense
                clearable
              ></v-text-field
            ></v-col>
          </v-row>
        </v-col>
      </template>
    </v-data-table>
    <v-dialog persistent v-model="dialogDelete" width="500">
      <v-card>
        <v-card-title class="border border-bottom">Delete</v-card-title>
        <v-card-text class="h5 py-3"
          >Are you sure you want to delete this prameter?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            small
            color="primary"
            outlined
            @click="deleteItemConfirm"
          >
            <v-icon>mdi-check</v-icon>
          </v-btn>
          <v-btn depressed small color="primary" outlined @click="closeDelete"
            ><v-icon>mdi-close</v-icon></v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </section>
</template>
<script>
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import partnerService from "@/services/partnerService/partnerService.js";
export default {
  name: "Branch Summary",
  mixins: [alerts],
  data() {
    return {
      loader: false,
      dialogDelete: false,
      search: "",
      parent_partner_id: "",
      BranchesData: [],
      headers: [
        { text: "Id", value: "branch_id" },
        { text: "Name", value: "branch_name" },
        { text: "Branch code", value: "branch_code" },
        { text: "Alpha code", value: "alpha_code" },
        { text: "Email", value: "email" },
        { text: "Mobile number", value: "mobile_number" },
        { text: "Country", value: "country" },
        { text: "Address", value: "address" },
        { text: "Action", value: "actions", sortable: false },
      ],
    };
  },
  components: {
    Loading,
    BreadCrumb,
  },
  mounted() {
    this.parent_partner_id = this.$route.query.parent_partner_id;
    console.log(this.parent_partner_id);
    this.getAllBranches();
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },
    async downloadExcelsheet() {
      if (this.BranchesData) {
        this.exportToExcel(this.headers, this.BranchesData, "Branch Summary");
      }
    },
    async getAllBranches() {
      this.loader = true;
      try {
        const responseData = await partnerService.getPartnerBranches(
          this.parent_partner_id
        );
        if (responseData.data.status_code == 200) {
          this.BranchesData = responseData.data.data;
          this.stoploader();
        }
        // else if(responseData.data.status_code == 401){
        //   this.returnNewToken();
        //   this.getAllBranchesById();
        // }
        else {
          this.showAlertError("Failed" + responseData.data.message);
          this.loader = false;
        }
        console.log("branch summary", responseData);
      } catch (e) {
        console.log(e);
        this.showAlertError("Fetch data Failed : Something went wrong");
        this.loader = false;
      }
    },
    editItem(item) {
      console.log(item);
      setTimeout(() => {
        this.$router.push({
          name: "Branch Setup",
          params: item,
          query: {
            parent_partner_id: this.parent_partner_id,
            branch_id: item.branch_id,
            country_cd: this.$route.query.country_cd,
          },
        });
      }, 300);
    },
    deleteItem(item) {
      console.log("item", item);
      this.dialogDelete = true;
      this.deleteId = item.branch_id;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.deleteId = "";
      });
    },
    async deleteItemConfirm() {
      this.loader = true;
      try {
        const responseData = await partnerService.deletePartnerBranch(
          this.deleteId
        );
        this.response = responseData;
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getAllBranches();
          this.stoploader();
        } else {
          this.showAlertError("Failed:" + responseData.data.message);
          this.loader = false;
        }
      } catch (e) {
        console.log(e);
        this.showAlertError("One or more parameter is invalid or missing!");
        this.loader = false;
      }

      this.closeDelete();
    },
  },
};
</script>
